import React, { useEffect } from "react";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useMutation, useQuery } from "@apollo/client";
import physicians from "../../gql/physicians";
import { useNavigate } from "react-router-dom";
import PhysiansLoading from "../../common/PhysiansLoading";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../shared/CustomFilterInput";
import AppButton from "../../shared/AppButton";

function AddPhysicianDetailForm({ item }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const roles = [
    { id: "Doctor", name: "Doctor" },
    { id: "Nurse", name: "Nurse" },
    { id: "Pharmist", name: "Pharmist" },
    { id: "Researcher", name: "Researcher" },
    { id: "Teacher/Educatoe", name: "Teacher/Educatoe" },
  ];

  const { loading: loadingSpeciality, data: dataSpeciality } = useQuery(
    physicians.GET_PHYSICIAN_SPECIALITY,
    {
      fetchPolicy: "network-only",
    },
  );

  const onSuccessfulRequestResponse = (data) => {
    if (data.registerPhysician) {
      toast.success(data.registerPhysician.message);
      formik.resetForm();
      navigate("/physicians");
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error?.message}`);
  };

  const [createPhysician, { loading }] = useMutation(
    physicians.CREATE_PHYSICIAN,
    {
      update(proxy, result) {
        onSuccessfulRequestResponse(result.data);
      },
      onError(error) {
        onResponseError(error.graphQLErrors[0]);
      },
    },
  );

  const [updatePhysician] = useMutation(physicians.UPDATE_PHYSICIAN, {
    update(proxy, result) {
      onSuccessfulEditResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulEditResponse = (data) => {
    if (data?.updatePhysician) {
      toast.success(data?.updatePhysician?.message);
      navigate("/physicians");
    }
  };

  //   const addData = (values) => {
  //     console.log("values :: ", values);
  //     toast.loading("Requesting!");

  //     let data = _.cloneDeep(values);

  //     if (item) {
  //       data["id"] = item.id;

  //       delete data.insurance_plans;
  //       // delete data.subscriber_relationship;
  //       delete data.beneficiary_file_id;

  //       editBeneficiary({ variables: { input: data } });
  //     } else {
  //       delete data.beneficiary_file_id;
  //       // delete data.subscriber_relationship;
  //       createPatient({ variables: { input: data } });
  //     }
  //   };

  //   const inValidBtn = (values) => {
  //     if (!values.is_new_born && values.insurance_plans.length < 1) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   };

  //   useEffect(() => {
  //     if (chiReqRecord) {
  //       formik.resetForm();
  //       formik.setFieldValue("full_name", chiReqRecord?.Insurance[0]?.Name || "");
  //       formik.setFieldValue(
  //         "document_id",
  //         chiReqRecord?.Insurance[0]?.IdentityNumber || ""
  //       );

  //       formik.setFieldValue(
  //         "gender",
  //         chiReqRecord?.Insurance[0]?.Gender == 1
  //           ? "male"
  //           : chiReqRecord?.Insurance[0]?.Gender == 2
  //           ? "female"
  //           : chiReqRecord?.Insurance[0]?.Gender == 3
  //           ? "unknown"
  //           : "other" || ""
  //       );
  //     }
  //   }, [chiReqRecord]);

  useEffect(() => {
    if (item) {
      formik.setValues({
        name: item?.name || "",
        document_id: item?.document_id || "",
        license: item?.license || "",
        role: item?.role || "",
        speciality: item?.speciality || "",
        speciality_item_index: item?.speciality_item_index || 0,
        code: item?.code || "",
        id: item?.id || "",
      });
    }
  }, [item]);

  const formik = useFormik({
    initialValues: {
      name: "",
      document_id: "",
      license: "",
      role: "",
      speciality: "",
      speciality_item_index: 0,
      code: "",
    },

    validationSchema: () => {
      return Yup.object().shape({
        name: Yup.string().required(t("Name is required")),
        license: Yup.string().required(t("License Number is required")),
        role: Yup.string().required(t("Role is required")),
        speciality: Yup.string().required(t("Speciality is required")),
      });
    },

    onSubmit: (values) => {
      if (item) {
        updatePhysician({ variables: { input: values } });
      } else {
        createPhysician({ variables: { input: values } });
      }
    },
  });

  return (
    <>
      {loading || loadingSpeciality ? (
        <PhysiansLoading />
      ) : (
        <div className="superGit_container">
          <div className="benefeciary-create">
            <div className="personal-data !shadow-none !p-3">
              <div className="flex items-center gap-2 !mb-2">
                <div className="inventory-svg">
                  <svg
                    width="26"
                    height="26"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="34" height="34" rx="8" fill="#F4F6F8" />
                    <path
                      d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                      fill="#0070C2"
                    />
                    <path
                      d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                      fill="#0070C2"
                    />
                  </svg>
                </div>
                <div className="personal-head">
                  <span>{t("Physician Data")}</span>
                </div>
              </div>
              <div className="personal-fields grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                <CustomFilterInput
                  label={t("Name*")}
                  placeholder={t("Enter Name")}
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.name}
                  touched={formik.touched.name}
                />

                <CustomFilterInput
                  label={t("License Number*")}
                  placeholder={t("Enter License Number")}
                  name="license"
                  value={formik.values.license}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.license}
                  touched={formik.touched.license}
                />

                <CustomFilterInput
                  label={t("Document ID")}
                  placeholder={t("Enter Document ID")}
                  name="document_id"
                  value={formik.values.document_id}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.document_id}
                  touched={formik.touched.document_id}
                />

                <CustomFilterInput
                  label={t("Speciality*")}
                  placeholder={t("Select Speciality")}
                  name="speciality_item_index"
                  value={formik.values.speciality_item_index}
                  isSelect
                  options={dataSpeciality?.getPhysicianSpeciality?.data?.map(
                    (item) => ({ id: item.id, name: item.display }),
                  )}
                  onChange={async (e) => {
                    const selectedId = e.target.value;
                    formik.setFieldValue("speciality_item_index", selectedId);
                    if (selectedId) {
                      const val =
                        dataSpeciality?.getPhysicianSpeciality?.data.find(
                          (sp) => sp.id == selectedId,
                        );

                      if (val) {
                        formik.setFieldValue("speciality", val?.display || "");
                        formik.setFieldValue("code", val?.code || "");
                      }
                    } else {
                      formik.setFieldValue("speciality", "");
                      formik.setFieldValue("code", "");
                    }
                  }}
                  onBlur={formik.handleBlur}
                  error={formik.errors.speciality}
                  touched={formik.touched.speciality}
                />

                <CustomFilterInput
                  label={t("Role*")}
                  placeholder={t("Select Role")}
                  name="role"
                  value={formik.values.role}
                  isSelect
                  options={roles}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.errors.role}
                  touched={formik.touched.role}
                />
              </div>

              <div className="flex justify-center mt-2">
                <AppButton
                  label={item ? t("Update Physician") : t("Save Physician")}
                  onClick={formik.handleSubmit}
                  isLoading={loading}
                  className="!w-full sm:!w-auto"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddPhysicianDetailForm;
